import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { DialogModule } from 'primeng/dialog';
import { PasswordModule } from 'primeng/password';
import { MensajesService } from '../../../services/mensajes.service';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrl: './login-page.component.css',
    imports: [FormsModule, CommonModule, PaginatorModule, DialogModule, ReactiveFormsModule,
        PasswordModule,],
})
export class LoginPageComponent {

    private fb = inject(FormBuilder);
    public authService = inject(AuthService);
    private router = inject(Router);
    private mensajeService = inject(MensajesService);

    public myForm: FormGroup = this.fb.group({
        email: [null, [Validators.required]],
        password: [null, [Validators.required, Validators.minLength(6)]],
    });

    verificarShowLogin(): boolean {
        return this.authService.visible_login
    }

    login() {
        if (this.myForm.invalid) {
            this.myForm.markAllAsTouched();
            const emailCtrl = this.myForm.get('email');
            const passCtrl = this.myForm.get('password');

            if (emailCtrl?.hasError('required')) {
                this.mensajeService.showError('El usuario es obligatorio');
            }

            if (passCtrl?.hasError('required')) {
                this.mensajeService.showError('La contraseña es obligatoria');
            } else if (passCtrl?.hasError('minlength')) {
                this.mensajeService.showError('La contraseña debe tener al menos 6 caracteres');
            }
            return;
        }

        const { email, password } = this.myForm.value;

        //console.debug(email, password)
        this.authService.login(email, password)
            .subscribe({
                next: () => {
                    this.router.navigateByUrl('/');
                    this.authService.visible_login = false;
                },
                error: (errorDetail: any) => {
                    let msg = 'Usuario o clave incorrecto';
                    if (typeof errorDetail === 'string') {
                        msg = errorDetail;
                    } else if (Array.isArray(errorDetail) && errorDetail.length > 0 && errorDetail[0]?.errorMessage) {
                        msg = errorDetail[0].errorMessage;
                    } else if (errorDetail?.error?.message) {
                        msg = errorDetail.error.message;
                    } else if (errorDetail?.message) {
                        msg = errorDetail.message;
                    }

                    if (/autorizado/i.test(msg) || /unauthori[sz]ed/i.test(msg)) {
                        msg = 'Usuario o clave incorrecto';
                    }

                    this.mensajeService.showError(msg);
                }
            })

    }

    loginInvitado() {

        this.authService.login('', '')
            .subscribe({
                next: () => {
                    this.router.navigateByUrl('/');
                },
                error: (errorDetail: any) => {
                    let msg = 'Usuario o clave incorrecto';
                    if (typeof errorDetail === 'string') {
                        msg = errorDetail;
                    } else if (Array.isArray(errorDetail) && errorDetail.length > 0 && errorDetail[0]?.errorMessage) {
                        msg = errorDetail[0].errorMessage;
                    }

                    if (/autorizado/i.test(msg) || /unauthori[sz]ed/i.test(msg)) {
                        msg = 'Usuario o clave incorrecto';
                    }

                    this.mensajeService.showError(msg);
                }
            })

    }
}
